import { render, staticRenderFns } from "./_sprint-selector.vue?vue&type=template&id=3637c863&"
import script from "./_sprint-selector.vue?vue&type=script&lang=js&"
export * from "./_sprint-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports